import { z } from 'zod';
/**
 * Internal HospaSense Control operator roles.
 *
 * These are SenseSys-internal roles only. They are entirely disjoint from
 * HospaSense hospital-tenant roles: a tenant "Super Admin" is NOT a Control
 * role and must never be mapped onto one.
 */
export const ROLE_KEYS = [
    'product_owner',
    'product_operations',
    'customer_success',
    'finance',
    'support_engineer',
    'release_manager',
    'security_privacy_officer',
    'auditor',
    'readonly_analyst',
];
export const RoleKeySchema = z.enum(ROLE_KEYS);
export const ROLE_LABELS = {
    product_owner: 'Product Owner',
    product_operations: 'Product Operations',
    customer_success: 'Customer Success',
    finance: 'Finance',
    support_engineer: 'Support Engineer',
    release_manager: 'Release Manager',
    security_privacy_officer: 'Security & Privacy Officer',
    auditor: 'Auditor',
    readonly_analyst: 'Read-only Analyst',
};
//# sourceMappingURL=roles.js.map